var _desc, _use, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-17.582 -4.664 71.571 87.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Nepal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Coding according to the official construction in \"Constitution of the Kingdom of Nepal, Article 5, Shedule 1\", adopted in November 1990")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    stroke: "#003893",
    strokeWidth: 5.1646754223
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M -15,37.5735931288 h 60 L -15,0 v 80 h 60 L -15,20 z",
    fill: "#DC143C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -11.9502769431,23.4834957055 A 12.8400974233,12.8400974233 0 0,0 11.9502769431,23.4834957055 A 11.9502769431 11.9502769431 0 0,1 -11.9502769431,23.4834957055"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,29.0445562765) scale(5.5610605710)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "jags6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jags3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jag",
    d: "M 0.195090322016,-0.980785280403 L 0,-1.388784109750 L -0.195090322016,-0.980785280403",
    transform: "rotate(11.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jag",
    transform: "rotate(22.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jag",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jags3",
    transform: "rotate(67.5)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jags6",
    transform: "scale(-1, 1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,58.7867965644) scale(8.1433982822)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "rays4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rays2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ray",
    d: "M 0.258819045103,0.965925826289 L 0,1.576749285537 L -0.258819045103,0.965925826289"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ray",
    transform: "rotate(180)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays2",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays4",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays4",
    transform: "rotate(60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.f6d8de219fef3980fedca335c14b24d0.svg";
export { ForwardRef as ReactComponent };